// WRAP ALL IN ONE DIV JS START

function wrapFooterMenus() {
  const otherMenu = document.querySelector(".footer-block--menu.other_menu_enable");
  const nlMenu = document.querySelector(".footer-block--menu.nl_enable");

  // Check if both elements exist and wrapper doesn't already exist
  if (otherMenu && nlMenu && !document.querySelector(".footer-block_menu_nl_wrapper")) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("footer-block_menu_nl_wrapper");

    // Insert wrapper before the first element
    otherMenu.parentNode.insertBefore(wrapper, otherMenu);

    // Move both elements into the wrapper
    wrapper.appendChild(otherMenu);
    wrapper.appendChild(nlMenu);
  }
}

document.addEventListener("DOMContentLoaded", wrapFooterMenus);
window.addEventListener("resize", wrapFooterMenus);
window.addEventListener("orientationchange", wrapFooterMenus);

function wrapFooterBlockMenus() {
  const footerBlocks = document.querySelectorAll('.footer-block--menu');

  footerBlocks.forEach(block => {
    // Prevent double-wrapping
    if (!block.querySelector('.footer-block--menu_wrapper')) {
      const heading = block.querySelector('.footer-block__heading');
      const content = block.querySelector('.footer-block__details-content');

      if (heading && content) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('footer-block--menu_wrapper');

        // Insert wrapper before heading
        block.insertBefore(wrapper, heading);

        // Move heading and content into wrapper
        wrapper.appendChild(heading);
        wrapper.appendChild(content);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", wrapFooterBlockMenus);
window.addEventListener("resize", wrapFooterBlockMenus);
window.addEventListener("orientationchange", wrapFooterBlockMenus);

// WRAP ALL IN ONE DIV JS END

// TESTIMONIAL SLIDER JS START

$('.testimonial-wrapper').each(function() {
  const $wrap = $(this);
  $wrap.find('.testimonial_slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: true,
    appendArrows: $wrap.find('.testimonial-arrows'),
    prevArrow: `
      <button type="button" class="slick-prev" aria-label="Previous">
        <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M34 12L4 12" stroke="white" stroke-width="2" stroke-linejoin="round"/>
          <path d="M10.5 5.25L3.75 12L10.5 18.75" stroke="white" stroke-width="2"/>
        </svg>
      </button>`,
      nextArrow: `
        <button type="button" class="slick-next" aria-label="Next">
          <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 12L34 12" stroke="white" stroke-width="2" stroke-linejoin="round"/>
            <path d="M27.5 5.25L34.25 12L27.5 18.75" stroke="white" stroke-width="2"/>
          </svg>
        </button>`,

    slidesToShow: 3,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

// document.addEventListener('DOMContentLoaded', () => {
//   const variantDropdowns = document.querySelectorAll('select[name="variant-dropdown"]');

//   variantDropdowns.forEach(variantDropdown => {
//     variantDropdown.addEventListener('change', (event) => {
//       const parentElement = event.target.closest(".card-wrapper");
//       const idInput = parentElement.querySelector('input[type="hidden"][name="id"]');
//       idInput.value = event.target.value;
//     });
//   });

//   let bundlesVariantItemBtns = document.querySelectorAll('.bundles-variant_item-btn');

//   // Toggle logic
//   bundlesVariantItemBtns.forEach(bundlesVariantItemBtn => {
//     bundlesVariantItemBtn.addEventListener('click', (e) => {

//       let bundlesVariantsContainer = bundlesVariantItemBtn.closest(".bundles-variants-container");
//       if (!bundlesVariantsContainer) return;

//       let isAlreadyActive = bundlesVariantsContainer.classList.contains("active");

//       // Remove active from all
//       document.querySelectorAll(".bundles-variants-container.active")
//         .forEach(el => el.classList.remove("active"));

//       // If it was not active before, activate it
//       if (!isAlreadyActive) {
//         bundlesVariantsContainer.classList.add("active");
//       }

//       // Prevent event from bubbling to document
//       e.stopPropagation();
//     });
//   });

//   // Outside click handler
//   document.addEventListener('click', function (event) {
//     if (!event.target.closest('.bundles-variants-container')) {
//       document.querySelectorAll(".bundles-variants-container.active")
//         .forEach(el => el.classList.remove("active"));
//     }
//   });

//   const variantDropdownsUls = document.querySelectorAll('ul.bundles-variants[name="variant-dropdown"]');

//   variantDropdownsUls.forEach(variantDropdownsUl => {
//     let variantDropdownsUlList = variantDropdownsUl.querySelectorAll("li.bundles-variant_item");
//     variantDropdownsUlList.forEach(element => {
//       element.addEventListener('click', (event) => {
//         const parentElement = element.closest(".card-wrapper");
//         const idInput = parentElement.querySelector('input[type="hidden"][name="id"]');
//         idInput.value = element.dataset.value;

//         let bundlesVariantsContainer = element.closest(".bundles-variants-container");
//         if(bundlesVariantsContainer){
//           let bundlesVariantItemLabel = bundlesVariantsContainer.querySelector(".bundles-variant_item_label");
//           let bundlesVariantItemPrice = bundlesVariantsContainer.querySelector(".bundles-variant_item_price");
//           bundlesVariantItemLabel.innerHTML = element.dataset.label;
//           bundlesVariantItemPrice.innerHTML = element.dataset.price;

//           if(bundlesVariantsContainer.classList.contains("active")){
//             bundlesVariantsContainer.classList.remove("active");
//           }
//         }
//       });
//     });
    
//   });

// });

document.addEventListener('DOMContentLoaded', () => {
  const variantDropdowns = document.querySelectorAll('select[name="variant-dropdown"]');
  variantDropdowns.forEach(variantDropdown => {
    variantDropdown.addEventListener('change', (event) => {

      const parentElement = event.target.closest(".card-wrapper");
      if (!parentElement) return;

      const idInput = parentElement.querySelector('input[type="hidden"][name="id"]');
      if (idInput) {
        idInput.value = event.target.value;
      }

      /* Activate current grid item */
      const gridItem = parentElement.closest(".grid__item");
      if (gridItem) {
        document.querySelectorAll(".grid__item.active")
          .forEach(el => el.classList.remove("active"));

        gridItem.classList.add("active");
      }

    });
  });


  /* ===============================
     Bundle Button Toggle Logic
  =============================== */
  let bundlesVariantItemBtns = document.querySelectorAll('.bundles-variant_item-btn');

  bundlesVariantItemBtns.forEach(bundlesVariantItemBtn => {
    bundlesVariantItemBtn.addEventListener('click', (e) => {

      let bundlesVariantsContainer = bundlesVariantItemBtn.closest(".bundles-variants-container");
      if (!bundlesVariantsContainer) return;

      let isAlreadyActive = bundlesVariantsContainer.classList.contains("active");

      // Remove active from all containers
      document.querySelectorAll(".bundles-variants-container.active")
        .forEach(el => el.classList.remove("active"));

      // Remove active from all grid items
      document.querySelectorAll(".grid__item.active")
        .forEach(el => el.classList.remove("active"));

      // Activate current if not already active
      if (!isAlreadyActive) {
        bundlesVariantsContainer.classList.add("active");

        const gridItem = bundlesVariantItemBtn.closest(".grid__item");
        if (gridItem) {
          gridItem.classList.add("active");
        }
      }

      e.stopPropagation();
    });
  });


  /* ===============================
     Outside Click Handler
  =============================== */
  document.addEventListener('click', function (event) {

    if (!event.target.closest('.bundles-variants-container')) {

      document.querySelectorAll(".bundles-variants-container.active")
        .forEach(el => el.classList.remove("active"));

      document.querySelectorAll(".grid__item.active")
        .forEach(el => el.classList.remove("active"));
    }

  });


  /* ===============================
     Custom UL Variant Dropdown Logic
  =============================== */
  const variantDropdownsUls = document.querySelectorAll('ul.bundles-variants[name="variant-dropdown"]');

  variantDropdownsUls.forEach(variantDropdownsUl => {

    let variantDropdownsUlList = variantDropdownsUl.querySelectorAll("li.bundles-variant_item");

    variantDropdownsUlList.forEach(element => {

      element.addEventListener('click', () => {

        const parentElement = element.closest(".card-wrapper");
        if (!parentElement) return;

        const idInput = parentElement.querySelector('input[type="hidden"][name="id"]');
        if (idInput) {
          idInput.value = element.dataset.value;
        }

        let bundlesVariantsContainer = element.closest(".bundles-variants-container");

        if (bundlesVariantsContainer) {

          let bundlesVariantItemLabel = bundlesVariantsContainer.querySelector(".bundles-variant_item_label");
          let bundlesVariantItemPrice = bundlesVariantsContainer.querySelector(".bundles-variant_item_price");

          if (bundlesVariantItemLabel) {
            bundlesVariantItemLabel.innerHTML = element.dataset.label;
          }

          if (bundlesVariantItemPrice) {
            bundlesVariantItemPrice.innerHTML = element.dataset.price;
          }

          bundlesVariantsContainer.classList.remove("active");
        }

        /* Activate corresponding grid item */
        const gridItem = element.closest(".grid__item");

        document.querySelectorAll(".grid__item.active")
          .forEach(el => el.classList.remove("active"));

        if (gridItem) {
          gridItem.classList.add("active");
        }

      });

    });

  });

});

function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  requestAnimationFrame(() => {
    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

function initMatchHeight() {
  matchHeight('.product-card-wrapper .card__heading');
  matchHeight('.article-card-wrapper .card__heading');
}

document.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('load', initMatchHeight);